export default __webpack_public_path__ + "static/media/mail.36c719c7.svg";